import { useState, useEffect } from "react";

// Utility function to validate image URL
const validateImageUrl = (url: string): Promise<boolean> => {
  return new Promise((resolve) => {
    if (!url || url.startsWith("data:")) {
      resolve(false);
      return;
    }

    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = url;

    // Timeout after 3 seconds
    setTimeout(() => resolve(false), 3000);
  });
};

// Hook to manage image validation and fallback
export const useValidatedImageUrl = (imageUrl: string, fallbackUrl: string) => {
  const [validatedUrl, setValidatedUrl] = useState<string>(fallbackUrl);
  const [isValidating, setIsValidating] = useState<boolean>(false);

  useEffect(() => {
    if (!imageUrl || imageUrl === fallbackUrl) {
      setValidatedUrl(fallbackUrl);
      return;
    }

    setIsValidating(true);
    validateImageUrl(imageUrl)
      .then((isValid) => {
        setValidatedUrl(isValid ? imageUrl : fallbackUrl);
      })
      .catch(() => {
        setValidatedUrl(fallbackUrl);
      })
      .finally(() => {
        setIsValidating(false);
      });
  }, [imageUrl, fallbackUrl]);

  return { validatedUrl, isValidating };
};
